import React, { useState, useEffect } from "react";
// import { Modal, Button } from "react-bootstrap";
import LoadingBar from "react-top-loading-bar";
import { useParams, useNavigate } from "react-router-dom";
import {
  Radio,
  TableContainer,
  Paper,
  Container,
  Typography,
  Box,
  Modal,
  Button,
  Select,
  Grid,
  TextField,
  FormGroup,
  FormControlLabel,
  TableCell,
  Tooltip,
  TableBody,
  TableRow,
  Table,
  TableHead,
  MenuItem,
  Input,
  FormControl,
  Checkbox,
  InputLabel,
  IconButton,
  Toolbar,
  AppBar,
} from "@mui/material";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import DeleteIcon from "@mui/icons-material/Delete";
// import { Navigate, useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const UpdateAdmission = () => {
const [newFiles, setNewFiles] = useState({});
  const [hostelRoomNo, setHostelRoomNo] = useState("");
const [hostelAmount, setHostelAmount] = useState("");
const [hostelMonth, setHostelMonth] = useState("");
const [selectedHostelItems, setSelectedHostelItems] = useState([]);

  const [classOrSectionChanged, setClassOrSectionChanged] = useState(false);
  //nabil
  const [isMaster, setIsMaster] = useState(false);
const [branches, setBranches] = useState([]);
const [selectedBranchId, setSelectedBranchId] = useState(null);
// Inside your component:
const [searchParams] = useSearchParams();
const branchIdFromQuery = searchParams.get("Branch_Id");

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  // Add these with your other state declarations

  const [selectedTransportItems, setSelectedTransportItems] = useState([]);
  const [transportAmount, setTransportAmount] = useState("");
  const [transportMonth, setTransportMonth] = useState("");
  const [selectedRouteID, setSelectedRouteID] = useState("");
  const [routes, setRoutes] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [routeMessage, setRouteMessage] = useState("");
  //nabil
  const [financialYears, setFinancialYears] = useState([]);
  const [parentsDobChecked, setParentsDobChecked] = useState(false);
  const [regisData, setRegisData] = useState([]);
  const [registrationNo, setRegistrationNo] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [nationality, setNationality] = useState([]);
  const [religion, setReligion] = useState([]);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [ddlClass, setddlClass] = useState([]);
  const [ddlSection, setddlSection] = useState([]);
  const [rollNo, setRollNo] = useState("");
  const [occupation, setOccupation] = useState([]);
  const [gender, setGender] = useState([]);
  const [bloodgrp, setBloodgrp] = useState([]);
  const [concessionData, setConcessionData] = useState([]);
  const [month, setMonth] = useState([]);
  const [isTransport, setIsTransport] = useState(false);
  const [isHostel, setIsHostel] = useState(false);
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [showDuplicateConcessionModal, setShowDuplicateConcessionModal] =
    useState(false);
  const [duplicateMonth, setDuplicateMonth] = useState("");
  const [caste, setCaste] = useState([]);
  const [registrationData, setRegistrationData] = useState({
    admissionDate: "",
    StudentLedgerNo: "",
    casteId: "",
    admissionNo: "",
    financialYearID: "",
    registrationNo: "",
    dated: "",
    studentName: "",
    studentLastName: "",
    classId: "",
    sectionId: "",
    newRollNo: "",
    dob: "",
    age: "",
    emailId: "",
    adhaarNo: "",
    certificateNo: "",
    mobileNo: "",
    address: "",
    nationalityId: "",
    religionId: "",
    countryId: "",
    stateId: "",
    cityId: "",
    genderId: "",
    bloodGourpId: "",
    lastSchoolAttended: "",
    paymentType: "",
    fathersNmae: "",
    fdob: "",
    mdob: "",
    isTransport: "",
    isHostel: "",
    annualAmount: "",
    mothersName: "",
    fathersMobile: "",
    mothersMobile: "",
    fathersEmail: "",
    mothersEmail: "",
    grandFathersNmae: "",
    fathersIncome: "",
    mothersIncome: "",
    fathersAdhaar: "",
    mothersAdhaar: "",
    fathersAddress: "",
    mothersAddress: "",
    parentsDobChecked: false,
    mothersOccupationId: "",
    fathersOccupationId: "",
    studentImagePath: null,
    mothersImagePath: null,
    fathersImagePath: null,
    studentAdhaarFrontPath: null,
    studentAdhaarBackPath: null,
    birtcertificatePath: null,
    trfCertificatePath: null,
    othetFilePath: null,
    tempTransportData: [],
  });

  const [selectedConcession, setSelectedConcession] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedAmount, setSelectedAmount] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [duplicateRollNoMessage, setDuplicateRollNoMessage] = useState("");
  const [streams, setStreams] = useState([]);
  const [selectedStream, setSelectedStream] = useState("");
  const { studentId } = useParams();
  const [selectedLanguageType, setSelectedLanguageType] = useState("");
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [missingFields, setMissingFields] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [mobileError, setMobileError] = useState("");
  const [aadhaarError, setAadhaarError] = useState("");
  const navigate = useNavigate();
  const [seatExceeded, setSeatExceeded] = useState(false);

 // ADD THIS HERE (new constant, outside any function)
  const fileFieldMap = {
  studentprofile: {
    apiKey: "StudentImgPath",
    existingKey: "DocumentPaths.StudentImagePath",
    existingDataKey: "studentImagePath",
  },
  fatherprofile: {
    apiKey: "FatherImgPath",
    existingKey: "DocumentPaths.FathersImagePath",
    existingDataKey: "fathersImagePath",
  },
  motherprofile: {
    apiKey: "MotherImgPath",
    existingKey: "DocumentPaths.MothersImagePath",
    existingDataKey: "mothersImagePath",
  },
  studentAdhaarFrontPath: {
    apiKey: "AdharFrontDocumentPath",
    existingKey: "DocumentPaths.StudentAdhaarFrontPath",
    existingDataKey: "studentAdhaarFrontPath",
  },
  studentAdhaarBackPath: {
    apiKey: "AdharBackDocumentPath",
    existingKey: "DocumentPaths.StudentAdhaarBackPath",
    existingDataKey: "studentAdhaarBackPath",
  },
  birtcertificatePath: {
    apiKey: "BirthCertificateDocumentPath",
    existingKey: "DocumentPaths.BirtcertificatePath",
    existingDataKey: "birtcertificatePath",
  },
  trfCertificatePath: {
    apiKey: "TranferDocumentPath",
    existingKey: "DocumentPaths.TrfCertificatePath",
    existingDataKey: "trfCertificatePath",
  },
  othetFilePath: {
    apiKey: "OtherDocumentPath",
    existingKey: "DocumentPaths.OthetFilePath",
    existingDataKey: "othetFilePath",
  },
};

  const handleNumericInput = (e, field, maxLength) => {
    const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
    if (value.length <= maxLength) {
      setRegistrationData((prevData) => ({
        ...prevData,
        [field]: value,
      }));
    }
  };

  const fetchBranches = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/Branch/GetBranch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    });

    if (response.ok) {
      const data = await response.json();
      setBranches(data);
    } else {
      console.error("Failed to fetch branches");
    }
  } catch (error) {
    console.error("Error fetching branches:", error);
  }
};


  const fetchCaste = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Caste/GetCaste`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching caste data: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        setCaste([]);
        return;
      }
      setCaste(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("API request error:", error);
      setCaste([]);
    }
  };

  //nabil
  // Add these with your other handler functions
  const fetchRoutes = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Transportation/Route/routesdropdown`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (!response.ok) throw new Error(`Error fetching routes: ${response.status}`);

      const data = await response.json();
      const validRoutes = Array.isArray(data?.routes) ? data.routes : [];
      setRoutes(validRoutes);
    } catch (error) {
      console.error("Error fetching routes:", error);
      // alert("Failed to load transport routes.");
      setSnackbarMessage('Failed to load transport routes.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const handleAddTransportItem = () => {
    if (selectedRouteID && transportMonth && transportAmount && !isNaN(transportAmount)) {
      const selectedRoute = routes.find(route => route.routeID === parseInt(selectedRouteID));
      const selectedMonthObj = month.find(m => m.month === transportMonth);

      if (selectedRoute) {
        let itemsToAdd = [];

        if (registrationData.paymentType === "1") {
          // Annual payment - create just one item for all months
          itemsToAdd.push({
            routeId: selectedRoute.routeID,
            routeName: selectedRoute.routeName,
            month: "All",
            monthId: 0,
            amount: parseFloat(transportAmount),
            distance: selectedRoute.distance
          });
        } else {
          // General payment logic remains the same
          if (transportMonth === "All") {
            itemsToAdd = month.map(item => ({
              routeId: selectedRoute.routeID,
              routeName: selectedRoute.routeName,
              month: item.month,
              monthId: item.monthId,
              amount: parseFloat(transportAmount),
              distance: selectedRoute.distance
            }));
          } else {
            itemsToAdd.push({
              routeId: selectedRoute.routeID,
              routeName: selectedRoute.routeName,
              month: transportMonth,
              monthId: selectedMonthObj.monthId,
              amount: parseFloat(transportAmount),
              distance: selectedRoute.distance
            });
          }
        }

        setSelectedTransportItems(prev => [...prev, ...itemsToAdd]);

        // Clear inputs
        if (registrationData.paymentType === "0") {
          setSelectedRouteID("");
        }
        setTransportAmount("");
        setTransportMonth("");
      }
    }
  };

  const handleDeleteTransportItem = (index) => {
    setSelectedTransportItems(prev => prev.filter((_, i) => i !== index));
  };


  const handleAddHostelItem = () => {
  if (hostelMonth && hostelAmount && !isNaN(hostelAmount)) {
    let itemsToAdd = [];
    if (registrationData.paymentType === "1") {
      itemsToAdd.push({ month: "All", monthId: 0, amount: parseFloat(hostelAmount), roomNo: hostelRoomNo });
    } else {
      if (hostelMonth === "All") {
        itemsToAdd = month.map((item) => ({ month: item.month, monthId: item.monthId, amount: parseFloat(hostelAmount), roomNo: hostelRoomNo }));
      } else {
        const selectedMonthObj = month.find((m) => m.month === hostelMonth);
        itemsToAdd.push({ month: hostelMonth, monthId: selectedMonthObj?.monthId || 0, amount: parseFloat(hostelAmount), roomNo: hostelRoomNo });
      }
    }
    setSelectedHostelItems((prev) => [...prev, ...itemsToAdd]);
    if (registrationData.paymentType === "0") setHostelMonth("");
    setHostelAmount("");
    setHostelRoomNo("");
  }
};

const handleDeleteHostelItem = (index) => {
  setSelectedHostelItems((prev) => prev.filter((_, i) => i !== index));
};

  //nabil

  // Validate mobile number (10 digits)
  const validateMobile = (value, field) => {
    if (value.length > 0 && value.length !== 10) {
      setMobileError(`${field} must be exactly 10 digits.`);
    } else {
      setMobileError("");
    }
  };

  // Validate Aadhaar number (12 digits)
  const validateAadhaar = (value, field) => {
    if (value.length > 0 && value.length !== 12) {
      setAadhaarError(`${field} must be exactly 12 digits.`);
    } else {
      setAadhaarError("");
    }
  };

  // Format date from YYYY-MM-DD to DD/MM/YYYY and vice versa
  const formatDateToDDMMYYYY = (dateStr) => {
  if (!dateStr) return "";
  if (dateStr.includes("-")) {
    const [year, month, day] = dateStr.split("-");
    return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
  }
  if (dateStr.includes("/")) {
    const parts = dateStr.split("/");
    // Guard: if the second segment > 12, it can't be a month, so this
    // string is NOT valid DD/MM/YYYY — reject instead of silently passing it through.
    const month = parseInt(parts[1], 10);
    if (month < 1 || month > 12) {
      console.error("Invalid date passed to formatDateToDDMMYYYY:", dateStr);
      return "";
    }
    return dateStr;
  }
  return dateStr;
};

  const formatDateToYYYYMMDD = (dateStr) => {
    if (!dateStr) return "";
    if (dateStr.includes("/")) {
      const [day, month, year] = dateStr.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
    return dateStr; // Already in YYYY-MM-DD
  };

  const handleRollNoChange = (e) => {
    const rollNoValue = e.target.value;
    setRollNo(rollNoValue);
  };

  const checkDuplicateRollNo = async (rollNo) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Admission/CheckDuplicateRollNo`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          classId: registrationData.classId,
          sectionId: registrationData.sectionId,
          rollNo: Number(rollNo),
          sessionId: registrationData.financialYearID || null,
        }),
      });

      const data = await response.json();

      if (data.message === "Roll number already exists.") {
        setDuplicateRollNoMessage("Roll number is already taken.");
      } else {
        setDuplicateRollNoMessage("");
      }
    } catch (error) {
      console.error("Error checking duplicate roll number:", error);
    }
  };

  const [hasUserAddedConcession, setHasUserAddedConcession] = useState(false);

  const handleAddItem = () => {
    if (
      selectedConcession &&
      (selectedMonth || registrationData.paymentType === "1") && // Allow empty month if paymentType is annual
      selectedAmount &&
      !isNaN(selectedAmount)
    ) {
      const selectedConcessionObject = concessionData.find(
        (item) => item.concessionName === selectedConcession
      );

      if (selectedConcessionObject) {
        let itemsToAdd = [];

        if (registrationData.paymentType === "1") {
          // Annual payment - create just one item for all months
          itemsToAdd.push({
            concessionId: selectedConcessionObject.concessionId,
            concession: selectedConcession,
            month: "All",
            amount: parseFloat(selectedAmount),
          });
        } else {
          // General payment logic remains the same
          if (selectedMonth === "All") {
            itemsToAdd = month.map((item) => ({
              concessionId: selectedConcessionObject.concessionId,
              concession: selectedConcession,
              month: item.month,
              amount: parseFloat(selectedAmount),
            }));
          } else {
            itemsToAdd.push({
              concessionId: selectedConcessionObject.concessionId,
              concession: selectedConcession,
              month: selectedMonth,
              amount: parseFloat(selectedAmount),
            });
          }
        }

        setSelectedItems((prevItems) => [...prevItems, ...itemsToAdd]);

        // Clear selected values after adding item
        setSelectedConcession("");
        setSelectedAmount("");
        if (registrationData.paymentType !== "1") {
          setSelectedMonth(""); // Only clear month if not annual payment
        }
      }
    }
  };
  const handleCloseDuplicateConcessionModal = () => {
    setShowDuplicateConcessionModal(false);
    setDuplicateMonth("");
  };

  const handleDeleteItem = (index, month) => {
    setSelectedItems((prevItems) => {
      if (month) {
        // Delete only the specific month's concession
        return prevItems.filter(
          (item) =>
            !(
              item.month === month &&
              item.concessionId === prevItems[index].concessionId
            )
        );
      }
      // Delete the entire row (original behavior)
      return prevItems.filter((_, i) => i !== index);
    });
  };

  // Add a new function to clear all concessions
  const handleClearAll = () => {
    setSelectedItems([]);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleTransportChange = (e) => {
    setIsTransport(e.target.checked);
  };

  const handleHostelChange = (e) => {
    setIsHostel(e.target.checked);
  };

 const handleFileChange = (fieldName, event) => {
  const file = event.target.files[0];
  if (!file) return;
  const fileSizeKB = file.size / 1024;
  if (fileSizeKB > 200) {
    setSnackbarMessage("File size exceeds the limit of 200KB.");
    setOpenSnackbar(true);
    setSnackbarSeverity("error");
    event.target.value = null;
    return;
  }

  setNewFiles((prev) => ({
    ...prev,
    [fieldName]: file,
  }));
}; 

  const handleClassChange = (e) => {
  const selectedClassId = e.target.value;
  setClassOrSectionChanged(true); // Add this
  setRegistrationData((prevData) => ({
    ...prevData,
    classId: selectedClassId,
  }));
};

const handleSectionChange = (e) => {
  const selectedSectionId = e.target.value;
  setClassOrSectionChanged(true); // Add this
  setRegistrationData((prevData) => ({
    ...prevData,
    sectionId: selectedSectionId,
  }));
};

  const fetchStudentData = async () => {


    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");

    const response = await fetch(
      `${apiUrl}/Admission/FillStudentDatabyId_Update?Branch_Id=${branchId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ studentId: studentId }),
        }
      );
      if (!response.ok) {
        throw new Error(`Error fetching student data: ${response.status}`);
      }
      const data = await response.json();
      const studentData = data.objData || {};

      
      console.log("Raw student data:", studentData);

      // Set basic states
      setParentsDobChecked(studentData.isParentsDOB || false);
      setRollNo(studentData.rollNo || "");
      setSelectedStream(studentData.streamId || "");
      setSelectedLanguageType(
        studentData.languageType === "empty"
          ? ""
          : studentData.languageType || ""
      );
      setIsTransport(studentData.isTransport || false);
      setIsHostel(studentData.isHostel || false);

      // Set concession details
      if (data.concessionData && Array.isArray(data.concessionData)) {
        const formattedConcessions = data.concessionData.map((item) => ({
          concessionId: item.concessionTypeID,
          concession: item.concessionType,
          month: item.month,
          amount: parseFloat(item.charge),
        }));
        setSelectedItems(formattedConcessions);
      }

      if (data.hostelData && Array.isArray(data.hostelData)) {
  setRegistrationData((prevData) => ({
    ...prevData,
    tempHostelData: data.hostelData,
  }));
}

      // Update registrationData with student data and store transportData
      setRegistrationData((prevData) => ({
        ...prevData,
        ...studentData,
        financialYearID: studentData.sessionId || "",
        admissionNo: studentData.admissionNo || "",
        StudentLedgerNo: studentData.studentLedgerNo || "",
        dated: formatDateToDDMMYYYY(studentData.dated) || "",
        admissionDate: formatDateToDDMMYYYY(studentData.admissionDate) || "",
        dob: formatDateToDDMMYYYY(studentData.dob) || "",
        fdob: formatDateToDDMMYYYY(studentData.fathersDob) || "",
        mdob: formatDateToDDMMYYYY(studentData.mothersDob) || "",
        studentName: studentData.studentName || "",
        studentLastName: studentData.studentLastName || "",
        mobileNo: studentData.mobileNo || "",
        fathersNmae: studentData.fathersNmae || "",
        mothersName: studentData.mothersName || "",
        fathersMobile: studentData.fathersMobile || "",
        classId: studentData.classId || "",
        sectionId: studentData.sectionId || "",
        tempTransportData: data.transportData || [], // Store raw transport data
        studentAnualPack: studentData.totalAmount || "",
      }));
    } catch (error) {
      console.error("Error fetching student data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  //nabil adding useeffects

  useEffect(() => {
  if (month.length > 0 && registrationData.tempHostelData?.length > 0) {
    const formattedHostel = registrationData.tempHostelData.map((item) => {
      const matchedMonth = month.find((m) => parseInt(m.monthId) === parseInt(item.monthId));
      return {
        roomNo: item.roomNo || "",
        month: item.monthId === 0 ? "All" : matchedMonth?.month || "Unknown Month",
        monthId: item.monthId,
        amount: parseFloat(item.hostelCharges) || 0,
      };
    });
    setSelectedHostelItems(formattedHostel);
  }
}, [month, registrationData.tempHostelData]); 

  useEffect(() => {
  if (selectedBranchId && studentId) {
    fetchStudentData();
  }
}, [selectedBranchId, studentId]);

useEffect(() => {
  const isMasterUser = sessionStorage.getItem("is_Master") === "true";
  setIsMaster(isMasterUser);

  // Set the branchId from query parameter or sessionStorage
  const branchId = branchIdFromQuery || sessionStorage.getItem("branchId");
  setSelectedBranchId(branchId);

  if (isMasterUser) {
    fetchBranches();
  }
}, [branchIdFromQuery]);




  useEffect(() => {
    if (registrationData.paymentType === "1") {
      // Annual payment - set month to "All" and disable changing it
      setSelectedMonth("All");
    } else {
      // General payment - reset month selection
      setSelectedMonth("");
    }
  }, [registrationData.paymentType]);

  useEffect(() => {
    if (isTransport && selectedRouteID) {
      const selectedRoute = routes.find(route => route.routeID === parseInt(selectedRouteID));

      if (selectedRoute) {
        if (registrationData.paymentType === "1") {
          // Annual payment - set to all months and 12*charge
          setTransportMonth("All");
          const annualTransportAmount = (selectedRoute.routeCharge * 12).toString();
          setTransportAmount(annualTransportAmount);
          // Remove this line: we don't want to update studentAnualPack here
          // setRegistrationData(prev => ({ ...prev, studentAnualPack: annualAmount }));
        } else {
          // General payment - set to single month charge
          setTransportAmount(selectedRoute.routeCharge || "");
        }
      }
    }
  }, [registrationData.paymentType, isTransport, selectedRouteID, routes]);



  useEffect(() => {

    setSelectedItems([]);
    setSelectedConcession("");
    setSelectedMonth("");
    setSelectedAmount("");

    if (registrationData.paymentType === "1") {
      setSelectedMonth("All");
    } else {
      setSelectedMonth("");
    }

    // Clear all transport-related state when payment type changes
    setSelectedRouteID("");
    setSelectedTransportItems([]);
    setTransportAmount("");
    setTransportMonth("");
    setVehicles([]);
    setRouteMessage("");

    setSelectedHostelItems([]);
setHostelAmount("");
setHostelMonth("");
setHostelRoomNo("");


    setRegistrationData(prev => ({
      ...prev,
      routeId: 0,
      studentAnualPack: ""
    }));

    // If switching back to annual and there was a selected route, reinitialize
    if (registrationData.paymentType === "1" && selectedRouteID) {
      const selectedRoute = routes.find(r => r.routeID === parseInt(selectedRouteID));
      if (selectedRoute) {
        const annualItem = {
          routeId: selectedRoute.routeID,
          routeName: selectedRoute.routeName,
          month: "All months",
          monthId: 0,
          amount: parseFloat(selectedRoute.routeCharge * 12),
          distance: selectedRoute.distance
        };
        setSelectedTransportItems([annualItem]);
        setRegistrationData(prev => ({
          ...prev,
          studentAnualPack: (selectedRoute.routeCharge * 12).toString()
        }));
      }
    }
  }, [registrationData.paymentType]);

  useEffect(() => {
    if (routes.length > 0 && month.length > 0 && registrationData.tempTransportData?.length > 0) {
      const formattedTransport = registrationData.tempTransportData.map(item => {
        const matchedRoute = routes.find(r => r.routeID === parseInt(item.routeId));
        const matchedMonth = month.find(m => m.monthId === parseInt(item.monthId));

        return {
          routeId: item.routeId,
          routeName: matchedRoute?.routeName || "Unknown Route",
          distance: matchedRoute?.distance || "N/A",
          month: item.monthId === 0 ? "All months" : matchedMonth?.month || "Unknown Month",
          monthId: item.monthId,
          amount: parseFloat(item.routeCharges) || 0,
        };
      });

      // Only set if we have valid data
      if (formattedTransport.length > 0) {
        setSelectedTransportItems(formattedTransport);

        // // Set the first route as selected
        // const firstRoute = formattedTransport[0].routeId;
        // setSelectedRouteID(firstRoute.toString());

        // // Find and set vehicles for the first route
        // const selectedRoute = routes.find(r => r.routeID === parseInt(firstRoute));
        // if (selectedRoute) {
        //   setRouteMessage(selectedRoute.message || "");
        //   setVehicles(Array.isArray(selectedRoute.vehicles) ? selectedRoute.vehicles : []);
        // }
      }
    }
  }, [routes, month, registrationData.tempTransportData]);

  


  // Add useEffect to log when financialYearID changes
  useEffect(() => {
    console.log("Current financialYearID:", registrationData.financialYearID);
  }, [registrationData.financialYearID]);

  const fetchFinancialYears = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${apiUrl}/ClassPromotion/GetFinancialYear`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({}),
        }
      );
      if (!response.ok) {
        throw new Error(`Error fetching financial years: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        setFinancialYears([]);
        return;
      }
      setFinancialYears(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(error);
      setFinancialYears([]);
    }
  };

  const fetchRegistration = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Admission/FetchReg_Admission`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching registration: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        setRegisData([]);
        return;
      }
      setRegisData(Array.isArray(data) ? data : []);
      handleShow();
    } catch (error) {
      console.error(error);
      setRegisData([]);
    }
  };

  const fetchNationalityData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Nationality/GetNationality`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching nationality data: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        setNationality([]);
        return;
      }
      setNationality(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("API request error:", error);
      setNationality([]);
    }
  };

  const fetchReligionData = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Religion/GetReligion`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching religion data: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        setReligion([]);
        return;
      }
      setReligion(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("API request error:", error);
      setReligion([]);
    }
  };

  const fetchCountry = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Registration/ddlCountry`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching country data: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        setCountry([]);
        return;
      }
      setCountry(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("API request error:", error);
      setCountry([]);
    }
  };

  const fetchOcccupation = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Occupation/GetOccupation`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching occupation data: ${response.status}`);
      }
      const data = await response.json();
      setOccupation(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("API request error:", error);
      setOccupation([]);
    }
  };

  const fetchState = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Registration/ddlState`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ countryId: registrationData.countryId }),
      });
      if (!response.ok) {
        throw new Error(`Error fetching state data: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        setState([]);
        return;
      }
      setState(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("API request error:", error);
      setState([]);
    }
  };

  const fetchCity = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Registration/ddlCity`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ stateId: registrationData.stateId }),
      });
      if (!response.ok) {
        throw new Error(`Error fetching city data: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        setCity([]);
        return;
      }
      setCity(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("API request error:", error);
      setCity([]);
    }
  };

  const fetchddlClass = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching class data: ${response.status}`);
      }
      const data = await response.json();
      setddlClass(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(error);
      setddlClass([]);
    }
  };

  const fetchddlSection = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${apiUrl}/ClassPromotion/ddlSection_clsId`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({
            teacherId: 0,
            classId: registrationData.classId,
          }),
        }
      );
      if (!response.ok) {
        throw new Error(`Error fetching section data: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        setddlSection([]);
        return;
      }
      setddlSection(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(error);
      setddlSection([]);
    }
  };

  const fetchRollno = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const clientCode = sessionStorage.getItem("clientCode");
      const sectionId = registrationData.sectionId ? parseInt(registrationData.sectionId) : 0;
      const classId = registrationData.classId ? parseInt(registrationData.classId) : 0;
      if (!classId || !sectionId) {
        console.warn("Class ID or Section ID is missing");
        return;
      }

       const endpoint = clientCode === "PTSS"
      ? "/Admission/GetNewRollNoWithCode"
      : "/Admission/GetNewRollNo";

      const response = await fetch(`${apiUrl}${endpoint}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          classId: classId,
          sectionId: sectionId,
        }),
      });
      if (!response.ok) {
        throw new Error(`Error fetching roll number: ${response.status}`);
      }
      const data = await response.json();
      if (Array.isArray(data) && data.length > 0) {
        if (data[0].newRollNo && data[0].newRollNo.includes("Seat Exceeded")) {
          setSeatExceeded(true);
          setRollNo(data[0].newRollNo);
        } else {
          setSeatExceeded(false);
          setRollNo(data[0].newRollNo);
        }
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      console.error(error);
      setSeatExceeded(false);
    }
  };


  const fetchGender = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Admission/ddlGender`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching gender data: ${response.status}`);
      }
      const data = await response.json();
      setGender(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(error);
      setGender([]);
    }
  };

  const fetchBloodgrp = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Admission/ddlBloodGroup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching blood group data: ${response.status}`);
      }
      const data = await response.json();
      setBloodgrp(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(error);
      setBloodgrp([]);
    }
  };

  const fetchConcession = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Concession/GetConcession`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching concession data: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        setConcessionData([]);
        return;
      }
      setConcessionData(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("API request error:", error);
      setConcessionData([]);
    }
  };

  const fetchMonth = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Fine/GetMonthList`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching month data: ${response.status}`);
      }
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") {
        setMonth([]);
        return;
      }
      setMonth(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(error);
      setMonth([]);
    }
  };

  const fetchStreams = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Stream/GetAllStreams`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error("Error fetching streams");
      }
      const data = await response.json();
      if (
        data.msg === "No records found." ||
        !Array.isArray(data) ||
        data.length === 0
      ) {
        setStreams([]);
        setSelectedStream("");
      } else {
        setStreams(data);
        setSelectedStream("");
      }
    } catch (error) {
      console.error("Error fetching streams:", error);
      setStreams([]);
      setSelectedStream("");
    }
  };


  useEffect(() => {
    setSeatExceeded(false);
  }, [registrationData.classId, registrationData.sectionId]);


 useEffect(() => {
  if (registrationData.countryId) fetchState();
  if (registrationData.stateId) fetchCity();
  if (registrationData.classId) {
    fetchddlSection();
    if (classOrSectionChanged) {  // Only reset roll no and check seats on user change
      setRollNo("");
    }
  }
  if (registrationData.classId && registrationData.sectionId && classOrSectionChanged) {
    fetchRollno(); // Only fetch new roll no when user changes class/section
  }
}, [
  registrationData.countryId,
  registrationData.stateId,
  registrationData.classId,
  registrationData.sectionId,
]);

  useEffect(() => {
    setRegistrationData((prevData) => ({
      ...prevData,
      sectionId: "",
    }));
  }, [registrationData.classId]);

  useEffect(() => {
    const loadData = async () => {
      try {
        await Promise.all([
          fetchFinancialYears(),
          fetchNationalityData(),
          fetchReligionData(),
          fetchCountry(),
          fetchddlClass(),
          fetchOcccupation(),
          fetchBloodgrp(),
          fetchGender(),
          fetchConcession(),
          fetchMonth(),
          fetchStreams(),
          fetchRoutes(),
          fetchCaste(),
        ]);
        if (studentId) await fetchStudentData();
      } catch (error) {
        console.error("Error loading data:", error);
      }
    };
    loadData();
  }, [studentId]);

  useEffect(() => {
    if (studentId) fetchStudentData();
  }, [studentId]);

  // Ensure financial years load before student data
  useEffect(() => {
    const loadData = async () => {
      await fetchFinancialYears();
      if (studentId) await fetchStudentData();
    };
    loadData();
  }, [studentId]);

  useEffect(() => {
    if (registrationData.dob) calculateAge(registrationData.dob);
  }, [registrationData.dob]);

  const calculateAge = (dob) => {
    if (!dob || typeof dob !== "string" || !dob.includes("/")) {
      setRegistrationData({ ...registrationData, age: "" });
      return;
    }
    const [day, month, year] = dob.split("/");
    if (!day || !month || !year || isNaN(day) || isNaN(month) || isNaN(year)) {
      setRegistrationData({ ...registrationData, age: "" });
      return;
    }
    const dobDate = new Date(`${year}-${month}-${day}`);
    if (isNaN(dobDate.getTime())) {
      setRegistrationData({ ...registrationData, age: "" });
      return;
    }
    const today = new Date();
    let age = today.getFullYear() - dobDate.getFullYear();
    if (
      today.getMonth() < dobDate.getMonth() ||
      (today.getMonth() === dobDate.getMonth() &&
        today.getDate() < dobDate.getDate())
    ) {
      age--;
    }
    setRegistrationData({ ...registrationData, age: age.toString() });
  };

  const handleSave = async () => {
    const requiredFields = {
      "Admission Number": registrationData.admissionNo,
      "Student's First Name": registrationData.studentName,
      "Date of Birth": registrationData.dob,
      "Mobile Number": registrationData.mobileNo,
      // "Aadhar No": registrationData.adhaarNo,
      // "Mother's Name": registrationData.mothersName,
      "Father's Name": registrationData.fathersNmae,
      "Father's Mobile Number": registrationData.fathersMobile,
      Class: registrationData.classId,
      "Section": registrationData.sectionId,
    };

    const missing = Object.entries(requiredFields)
      .filter(([_, value]) => !value || value === "")
      .map(([name]) => name);

    // Additional validation for mobile and Aadhaar lengths
    if (registrationData.mobileNo && registrationData.mobileNo.length !== 10) {
      missing.push("Mobile Number (must be 10 digits)");
    }
    if (
      registrationData.fathersMobile &&
      registrationData.fathersMobile.length !== 10
    ) {
      missing.push("Father's Mobile Number (must be 10 digits)");
    }
    if (
      registrationData.mothersMobile &&
      registrationData.mothersMobile.length !== 10
    ) {
      missing.push("Mother's Mobile Number (must be 10 digits)");
    }
    if (registrationData.adhaarNo && registrationData.adhaarNo.length !== 12) {
      missing.push("Aadhaar Number (must be 12 digits)");
    }
    if (
      registrationData.fathersAdhaar &&
      registrationData.fathersAdhaar.length !== 12
    ) {
      missing.push("Father's Aadhaar Number (must be 12 digits)");
    }
    if (
      registrationData.mothersAdhaar &&
      registrationData.mothersAdhaar.length !== 12
    ) {
      missing.push("Mother's Aadhaar Number (must be 12 digits)");
    }

    if (missing.length > 0) {
      setMissingFields(missing);
      setShowValidationModal(true);
      return;
    }

    try {
      const apiUrl = `${process.env.REACT_APP_BASE_URL}/Admission/Id?Id=${studentId}`;
    const branchId = isMaster ? selectedBranchId : sessionStorage.getItem("branchId");
      setLoadingBarProgress(30);
      const token = sessionStorage.getItem("token");

      const selectedStreamObject = streams.find(
        (stream) => stream.streamID === selectedStream
      );
      const streamId = selectedStreamObject ? selectedStreamObject.streamID : 0;

      const transportDetails = selectedTransportItems.map((item, index) => ({
        [`TransportDetails[${index}].routeId`]: item.routeId,
        [`TransportDetails[${index}].monthId`]: item.monthId,
        [`TransportDetails[${index}].routeCharges`]: item.amount, // Match API field name
      }));
      const flattenedTransportDetails = Object.assign({}, ...transportDetails);

      const concessionsDetail = selectedItems.map((item, index) => ({
        [`concessionsDetail[${index}].concessionTypeID`]: item.concessionId,
        [`concessionsDetail[${index}].charge`]: item.amount,
        [`concessionsDetail[${index}].month`]: item.month,
      }));
      const flattenedConcessionsDetail = Object.assign(
        {},
        ...concessionsDetail
      );

      const payload = {
      admissionDate: formatDateToDDMMYYYY(formatDateToYYYYMMDD(registrationData.admissionDate)) || "",
        StudentLedgerNo: registrationData.StudentLedgerNo || "",
        casteId: registrationData.casteId || 0,
        studentFirstName: registrationData.studentName || "",
        studentLastName: registrationData.studentLastName || "",
        paymentType: registrationData.paymentType || "0",
        registrationId: registrationData.registrationId || 0,
        admissionNo: registrationData.admissionNo || "", // Fixed syntax error
        studentDOB: formatDateToDDMMYYYY(formatDateToYYYYMMDD(registrationData.dob)) || "",
        studentAge: registrationData.age || "0",
        rollNo: rollNo || "",
        address: registrationData.address || "empty",
        emailId: registrationData.emailId || "empty",
        lastSchoolAttended: registrationData.lastSchoolAttended || "empty",
        trfCertificationNo: registrationData.certificateNo || "empty",
        studentAdhaarNo: registrationData.adhaarNo || "",
        StreamId: streamId,
        LanguageType: selectedLanguageType || "empty",
        studentMobile: registrationData.mobileNo || "",
        fetherMobile: registrationData.fathersMobile || "",
        sessionId: registrationData.financialYearID || 4,
        classId: registrationData.classId || "",
        isHostel: isHostel || false,
        isTransport: isTransport || false,
        countryId: registrationData.countryId || 0,
        routeId: selectedRouteID || 1, // Use selectedRouteID if available
        pickAndDropLocationId: 1,
        religionId: registrationData.religionId || 0,
        stateId: registrationData.stateId || 0,
        cityId: registrationData.cityId || 0,
        nationalityId: registrationData.nationalityId || 0,
        bloodGroupId: registrationData.bloodGourpId || 0,
        genderId: registrationData.genderId || 0,
        sectionId: registrationData.sectionId || "",
        studentAnualPack: registrationData.paymentType === "1" ? parseFloat(registrationData.studentAnualPack) || 0 : 0,
        "parentsDetails.isDob": parentsDobChecked || false,
        "parentsDetails.fatherName": registrationData.fathersNmae || "",
        "parentsDetails.fatherMobile": registrationData.fathersMobile || "",
        "parentsDetails.fatherEmail": registrationData.fathersEmail || "",
        "parentsDetails.fatherAddress": registrationData.fathersAddress || "",
        "parentsDetails.fatherDob": formatDateToDDMMYYYY(formatDateToYYYYMMDD(registrationData.fdob)) || "",
        "parentsDetails.motherName": registrationData.mothersName || "",
        "parentsDetails.motherMobile": registrationData.mothersMobile || "",
        "parentsDetails.motherEmail": registrationData.mothersEmail || "",
        "parentsDetails.motherOccupation":
          registrationData.mothersOccupationId || 0,
        "parentsDetails.motherAddress": registrationData.mothersAddress || "",
        "parentsDetails.motherDob": formatDateToDDMMYYYY(formatDateToYYYYMMDD(registrationData.mdob)) || "",
        "parentsDetails.motherIncome": registrationData.mothersIncome || "",
        "parentsDetails.fatherIncome": registrationData.fathersIncome || "",
        "parentsDetails.granfatherName":
          registrationData.grandFathersNmae || "",
        "parentsDetails.fatherAdhaarNo": registrationData.fathersAdhaar || "",
        "parentsDetails.motherAdhaarNo": registrationData.mothersAdhaar || "",
        "parentsDetails.fatherOccupationId":
          registrationData.fathersOccupationId || 0,
       
        ...flattenedConcessionsDetail,
        ...flattenedTransportDetails,
        // StudentImgPath: registrationData.studentImagePath || null,
        // OtherDocumentPath: registrationData.othetFilePath || null,
        // TranferDocumentPath: registrationData.trfCertificatePath || null,
        // AdharBackDocumentPath: registrationData.studentAdhaarBackPath || null,
        // AdharFrontDocumentPath: registrationData.studentAdhaarFrontPath || null,
        // MotherImgPath: registrationData.mothersImagePath || null,
        // FatherImgPath: registrationData.fathersImagePath || null,
        // BirthCertificateDocumentPath:
        //   registrationData.birtcertificatePath || null,
      };

      console.log("Payload being sent:", payload);

     const formData = new FormData();
for (const key in payload) {
  if (payload[key] !== null && payload[key] !== undefined) {
    formData.append(key, payload[key]);
  }
}

      selectedHostelItems.forEach((item, index) => {
  formData.append(`hostelDetails[${index}].roomNo`, item.roomNo);
  formData.append(`hostelDetails[${index}].hostelCharges`, item.amount);
  formData.append(`hostelDetails[${index}].monthId`, item.monthId);
});

 // Existing path field in registrationData for each file key
const existingPathMap = {
  studentprofile: "studentImagePath",
  fatherprofile: "fathersImagePath",
  motherprofile: "mothersImagePath",
  studentAdhaarFrontPath: "studentAdhaarFrontPath",
  studentAdhaarBackPath: "studentAdhaarBackPath",
  birtcertificatePath: "birtcertificatePath",
  trfCertificatePath: "trfCertificatePath",
  othetFilePath: "othetFilePath",
};

Object.entries(fileFieldMap).forEach(([localKey, { apiKey, existingKey, existingDataKey }]) => {
  if (newFiles[localKey]) {
    // New file selected — send it under the "new file" key, and explicitly clear the existing-path key
    formData.append(apiKey, newFiles[localKey]);
    formData.append(existingKey, "");
  } else {
    // No new file — send the existing path under the "existing path" key, and explicitly clear the new-file key
    const existingValue = registrationData[existingDataKey];
    formData.append(existingKey, existingValue || "");
    // Do NOT append apiKey with a file — leave it unset since FormData can't send "null" for a file input;
    // omitting it signals no new file was uploaded.
  }
});
      
      const response = await fetch(`${apiUrl}&Branch_Id=${branchId}`, {
        method: "PUT",
        headers: { Authorization: token },
        body: formData,
      });

      if (response.ok) {
        console.log("Form data successfully saved");
        setLoadingBarProgress(100);
        setShowSuccessModal(true);

      } else {
        setLoadingBarProgress(100);
        const errorText = await response.text();
        console.error("Error response:", errorText);
        throw new Error(`Failed to save: ${errorText}`);
      }
    } catch (error) {
      setLoadingBarProgress(100);
      console.error("Save error:", error);
      // alert("An error occurred: " + error.message);
      setSnackbarMessage("An error occurred: " + error.message);
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };


  const handleCloseValidationModal = () => setShowValidationModal(false);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Container mt={5}>
      <LoadingBar
        progress={loadingBarProgress}
        color="rgb(152, 106, 182)"
        height={5}
      />
      <AppBar
        position="static"
        style={{ backgroundColor: "#0B1F3D", marginBottom: "15px" }}
      >
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Update Admission
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: '20px', marginTop: 6 }}>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel htmlFor="financialYearLabel" shrink>
                Session
              </InputLabel>
              <Select
                id="financialYear"
                value={registrationData.financialYearID || ""}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    financialYearID: e.target.value,
                  })
                }
                displayEmpty
                style={{ marginTop: "10px" }}
                inputProps={{
                  name: "financialYear",
                  id: "financialYearLabel",
                }}
              >
                <MenuItem value="" disabled>
                  Select year
                </MenuItem>
                {financialYears.length > 0 ? (
                  financialYears.map((year) => (
                    <MenuItem
                      key={year.financialYearID}
                      value={year.financialYearID}
                    >
                      {year.finanacialYear}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No financial years available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
  {isMaster && (
    <FormControl fullWidth disabled>
      <InputLabel id="branch-label">Branch</InputLabel>
      <Select
        labelId="branch-label"
        id="branch"
        value={selectedBranchId || ""}
        label="Branch"
        onChange={(e) => setSelectedBranchId(e.target.value)}
      >
        <MenuItem value="">
          <em>Select Branch</em>
        </MenuItem>
        {branches.map((branch) => (
          <MenuItem key={branch.branchId} value={branch.branchId}>
            {branch.branchName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )}
</Grid>

        </Grid>
        <Grid
          container
          spacing={3}
          alignItems="center"
          style={{ marginTop: "-15px" }}
        >
          <Grid item xs={12} sm={6}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <TextField
                label="Registration No"
                type="text"
                id="registrationNo"
                name="registrationNo"
                variant="outlined"
                fullWidth
                value={registrationData.registrationNo}
              />
              <Button
                variant="outlined"
                onClick={fetchRegistration}
                style={{ marginLeft: "8px" }}
                disabled='true'
              >
                🔍
              </Button>
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} marginTop="11px">
            <TextField
              id="registrationDate"
              label="Registration Date"
              type="date"
              value={formatDateToYYYYMMDD(registrationData.dated) || ""}
              variant="outlined"
              fullWidth
            onChange={(e) =>
  setRegistrationData({
    ...registrationData,
    dated: formatDateToDDMMYYYY(e.target.value),
  })
}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} marginTop="11px">
            <TextField
              id="admissionDate"
              label="Admission Date"
              type="date" // Changed to date for calendar picker
              value={formatDateToYYYYMMDD(registrationData.admissionDate) || ""} // Display in YYYY-MM-DD for picker
              variant="outlined"
              fullWidth
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  admissionDate: formatDateToDDMMYYYY(e.target.value), // Store as DD/MM/YYYY
                })
              }
              InputLabelProps={{
                shrink: true, // Ensures label doesn't overlap with date
              }}
            />
          </Grid>
        </Grid>
      </Paper>
      <div>
        <AppBar
          position="static"
          style={{ backgroundColor: "#0B1F3D" }}
          className="mt-4"
        >
          <Toolbar>
            <Typography variant="h5" component="div" style={{ fontWeight: 'bold' }}>
              Student Details
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
      <Paper elevation={3} style={{ padding: '20px', marginTop: 6 }}>
        <Grid container spacing={3} style={{ marginTop: "14px" }}>
          <Grid item xs={12} md={6}>
            <TextField
            disabled={sessionStorage.getItem("clientCode") !== "IDEAL"}
              id="admissionNo"
              label="Admission No. *"
              variant="outlined"
              value={registrationData.admissionNo}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  admissionNo: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>
          {/* <Grid item xs={12} md={6}>
    <TextField
      id="ledgerNo"
      label="Ledger No."
      variant="outlined"
      value={registrationData.StudentLedgerNo}
      onChange={(e) =>
        setRegistrationData({
          ...registrationData,
          StudentLedgerNo: e.target.value,
        })
      }
      type="number"
      fullWidth
       InputProps={{
                inputProps: { min: 0, style: { MozAppearance: 'textfield' } },
                sx: {
                  'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },
                },
              }}
    />
  </Grid> */}
       <Grid item xs={12} md={6}>
  <Typography variant="subtitle1" gutterBottom>
    Student's Profile
  </Typography>
  <Input
    type="file"
    className="form-control-file"
    id="studentprofile"
    onChange={(e) => handleFileChange("studentprofile", e)}
  />
  <Typography variant="caption" color="textSecondary" display="block">
    Max size: 200KB
  </Typography>
  {registrationData.studentImagePath && !newFiles.studentprofile && (
    <Box sx={{ mt: 1 }}>
      <img
        src={`${process.env.REACT_APP_BASE_URL.replace('/api', '')}/${registrationData.studentImagePath}`}
        alt="Student"
        style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 4 }}
      />
    </Box>
  )}
</Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "1px" }}>
          <Grid item xs={12} md={6}>
            <TextField
              id="firstName"
              label="First Name *"
              variant="outlined"
              value={registrationData.studentName}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  studentName: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              id="lastName"
              label="Last Name"
              variant="outlined"
              value={registrationData.studentLastName}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  studentLastName: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "-1px" }}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="class-label">Class *</InputLabel>
              <Select
                label="Class *"
                labelId="class-label"
                id="class"
                value={registrationData.classId || ""}
                onChange={handleClassChange}
              >
                <MenuItem value="">Select Class</MenuItem>
                {ddlClass.length > 0 ? (
                  ddlClass.map((item) => (
                    <MenuItem key={item.classId} value={item.classId}>
                      {item.className}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No classes available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="section-label">Section</InputLabel>
              <Select
                label="Section"
                labelId="section-label"
                id="section"
                value={registrationData.sectionId || ""}
                onChange={handleSectionChange}
              >
                <MenuItem value="">Select Section</MenuItem>
                {ddlSection.length > 0 ? (
                  ddlSection.map((item) => (
                    <MenuItem key={item.sectionId} value={item.sectionId}>
                      {item.sectionName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No sections available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "-1px" }}>
          <Grid item xs={12} md={6}>
            <TextField
              label="RollNo"
              variant="outlined"
              id="rollNo"
              value={rollNo}
              onChange={handleRollNoChange}
              onBlur={() => checkDuplicateRollNo(rollNo)}
              helperText={duplicateRollNoMessage}
              error={!!duplicateRollNoMessage}
              fullWidth
              InputLabelProps={{ shrink: true }}
              InputProps={{
                readOnly: true,
                style: { pointerEvents: "none", backgroundColor: "#f9f9f9" },
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              id="dob"
              type="date"
              label="D.O.B *"
              variant="outlined"
              value={formatDateToYYYYMMDD(registrationData.dob) || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  dob: formatDateToDDMMYYYY(e.target.value),
                })
              }
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              id="age"
              label="Age"
              variant="outlined"
              value={registrationData.age}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  age: e.target.value,
                })
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "-1px" }}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="nationality-label">Nationality</InputLabel>
              <Select
                labelId="nationality-label"
                id="nationality"
                label="Nationality"
                value={registrationData.nationalityId || ""}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    nationalityId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Nationality</MenuItem>
                {nationality.length > 0 ? (
                  nationality.map((item) => (
                    <MenuItem key={item.nationalityId} value={item.nationalityId}>
                      {item.nationality}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No nationalities available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="religion-label">Religion</InputLabel>
              <Select
                labelId="religion-label"
                id="religion"
                label="Religion"
                value={registrationData.religionId || ""}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    religionId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Religion</MenuItem>
                {religion.length > 0 ? (
                  religion.map((item) => (
                    <MenuItem key={item.religionID} value={item.religionID}>
                      {item.religionName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No religions available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "-1px" }}>
          <Grid item xs={12} md={6}>
            <TextField
              id="emailId"
              label="Email Id"
              variant="outlined"
              value={registrationData.emailId || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  emailId: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              id="lastschoolattended"
              label="Last School Attended"
              variant="outlined"
              value={registrationData.lastSchool || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  lastSchoolAttended: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "-1px" }}>
          <Grid item xs={12} md={6}>
            <TextField
              id="certificationNo"
              label="Certification No."
              variant="outlined"
              value={registrationData.certificateNo || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  certificateNo: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              id="aadharNo"
              label="Aadhar No."
              variant="outlined"
              value={registrationData.adhaarNo || ""}
              onChange={(e) => handleNumericInput(e, "adhaarNo", 12)}
              onBlur={(e) => validateAadhaar(e.target.value, "Student Aadhaar")}
              inputProps={{ maxLength: 12 }}
              type="text"
              fullWidth
              error={!!aadhaarError && registrationData.adhaarNo.length > 0}
              helperText={
                aadhaarError && registrationData.adhaarNo.length > 0
                  ? aadhaarError
                  : ""
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "-1px" }}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="gender-label">Gender</InputLabel>
              <Select
                label="Gender"
                labelId="gender-label"
                id="gender"
                value={registrationData.genderId || ""}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    genderId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Gender</MenuItem>
                {gender.length > 0 ? (
                  gender.map((item) => (
                    <MenuItem key={item.genderId} value={item.genderId}>
                      {item.gender}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No genders available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              id="mobileNo"
              label="Mobile No. *"
              variant="outlined"
              value={registrationData.mobileNo || ""}
              onChange={(e) => handleNumericInput(e, "mobileNo", 10)}
              onBlur={(e) => validateMobile(e.target.value, "Student Mobile")}
              inputProps={{ maxLength: 10 }}
              type="text"
              fullWidth
              error={!!mobileError && registrationData.mobileNo.length > 0}
              helperText={
                mobileError && registrationData.mobileNo.length > 0
                  ? mobileError
                  : ""
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "1px" }}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="bloodgroup-label">Blood Group</InputLabel>
              <Select
                labelId="bloodgroup-label"
                id="bloodgroup"
                label="Blood Group"
                value={registrationData.bloodGourpId || ""}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    bloodGourpId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Blood Group</MenuItem>
                {bloodgrp.length > 0 ? (
                  bloodgrp.map((item) => (
                    <MenuItem key={item.bloodGroupId} value={item.bloodGroupId}>
                      {item.bloodGroupName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No blood groups available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="country-label">Country</InputLabel>
              <Select
                labelId="country-label"
                id="country"
                label="Country"
                value={registrationData.countryId || ""}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    countryId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Country</MenuItem>
                {country.length > 0 ? (
                  country.map((item) => (
                    <MenuItem key={item.countryId} value={item.countryId}>
                      {item.countryName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No countries available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "1px" }}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="state-label">State</InputLabel>
              <Select
                labelId="state-label"
                id="state"
                label="State"
                value={registrationData.stateId || ""}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    stateId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select State</MenuItem>
                {state.length > 0 ? (
                  state.map((item) => (
                    <MenuItem key={item.stateId} value={item.stateId}>
                      {item.stateName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No states available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="city-label">City</InputLabel>
              <Select
                labelId="city-label"
                id="city"
                label="City"
                value={registrationData.cityId || ""}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    cityId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select City</MenuItem>
                {city.length > 0 ? (
                  city.map((item) => (
                    <MenuItem key={item.cityId} value={item.cityId}>
                      {item.cityName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No cities available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "1px" }}>
          <Grid item xs={12} md={6}>
            <TextField
              id="address"
              label="Address"
              value={registrationData.address || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  address: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="paymentType-label">Payment Type</InputLabel>
              <Select
                labelId="paymentType-label"
                id="paymentType"
                label="Payment Type"
                value={registrationData.paymentType || ""}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    paymentType: e.target.value,
                  })
                }
              >
                <MenuItem value="0">General</MenuItem>
                {/* <MenuItem value="1">Annual</MenuItem> */}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="caste-label">Caste</InputLabel>
              <Select
                labelId="caste-label"
                id="caste"
                label="Caste"
                value={registrationData.casteId || ""}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    casteId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Caste</MenuItem>
                {caste.length > 0 ? (
                  caste.map((item) => (
                    <MenuItem key={item.casteId} value={item.casteId}>
                      {item.casteName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No castes available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              id="ledgerNo"
              label="Ledger No."
              variant="outlined"
              value={registrationData.StudentLedgerNo}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  StudentLedgerNo: e.target.value,
                })
              }
              type="number"
              fullWidth
              InputProps={{
                inputProps: { min: 0, style: { MozAppearance: 'textfield' } },
                sx: {
                  'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
                    WebkitAppearance: 'none',
                    margin: 0,
                  },
                },
              }}
            />
          </Grid>
        </Grid>
        {registrationData.paymentType === "1" && (
          <Grid container spacing={3}>
            <Grid item md={6} sx={{ marginTop: 5 }}>
              <TextField
                id="annualAmount"
                label="Annual Amount"
                value={registrationData.studentAnualPack} // Use studentAnualPack directly
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    studentAnualPack: e.target.value, // Update only studentAnualPack
                  })
                }
                fullWidth
              />
            </Grid>
          </Grid>
        )}

        {/* //avail transport starts here */}

        {/* //nabil */}
        <Typography variant="h6" gutterBottom className="mt-4">
          <b>Avail Transport</b>
        </Typography>

        <FormControl component="fieldset">
          <Grid container spacing={2}>
            <Grid item>
              <FormControlLabel
                control={
                  <Radio
                    checked={isTransport === true}
                    onChange={() => {
                      setIsTransport(true);
                      setRegistrationData({
                        ...registrationData,
                        isTransport: true,
                      });
                    }}
                    name="transport"
                    color="primary"
                  />
                }
                label="Yes"
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                control={
                  <Radio
                    checked={isTransport === false}
                    onChange={() => {
                      setIsTransport(false);
                      setRegistrationData({
                        ...registrationData,
                        isTransport: false,
                        routeId: 0,
                      });
                    }}
                    name="transport"
                    color="primary"
                  />
                }
                label="No"
              />
            </Grid>
          </Grid>
        </FormControl>


        {isTransport && (
          <Grid container spacing={2} className="mt-6 items-center mb-6">
            <Grid item xs={12} md={12}>
              <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-md">
                <Grid container spacing={2} alignItems="center">
                  {/* Route Selection - Always shown when transport is enabled */}
                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth>
                      <InputLabel id="route-label">Select Route</InputLabel>
                      <Select
                        labelId="route-label"
                        id="route"
                        value={selectedRouteID || ""}
                        label="Select Route"
                        onChange={(e) => {
                          const selectedValue = e.target.value;
                          if (!selectedValue) {
                            setSelectedRouteID("");
                            setSelectedTransportItems([]);
                            setRegistrationData(prev => ({ ...prev, routeId: 0 }));
                            setRouteMessage("");
                            setVehicles([]);
                            setTransportAmount("");
                            return;
                          }

                          const selectedRoute = routes.find(
                            r => r.routeID === parseInt(selectedValue)
                          );

                          if (selectedRoute) {
                            setSelectedRouteID(selectedValue);
                            setRegistrationData(prev => ({
                              ...prev,
                              routeId: selectedRoute.routeID
                            }));
                            setRouteMessage(selectedRoute.message || "");
                            setVehicles(Array.isArray(selectedRoute.vehicles) ?
                              selectedRoute.vehicles : []);

                            // For both payment types, set the amount initially
                            const amount = registrationData.paymentType === "1"
                              ? selectedRoute.routeCharge * 12
                              : selectedRoute.routeCharge;

                            setTransportAmount(amount.toString());

                            if (registrationData.paymentType === "1") {
                              // For annual payment, set month to "All"
                              setTransportMonth("All");
                            }
                          }
                        }}
                      >
                        <MenuItem value="">Select Route</MenuItem>
                        {routes.map((route) => (
                          <MenuItem key={route.routeID} value={route.routeID}>
                            {route.routeName} - ({route.distance} km)
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Month Selection - Always shown but disabled for annual payment */}
                  <Grid item xs={12} md={3}>
                    <FormControl fullWidth>
                      <InputLabel id="route-month">Select Month</InputLabel>
                      <Select
                        labelId="route-month"
                        id="month"
                        value={transportMonth}
                        onChange={(e) => setTransportMonth(e.target.value)}
                        label="Select Month"
                        disabled={registrationData.paymentType === "1"} // Disable for annual
                      >
                        <MenuItem value="">Select Month</MenuItem>
                        <MenuItem value="All">All Months</MenuItem>
                        {month.map((item) => (
                          <MenuItem key={item.monthId} value={item.month}>
                            {item.month}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Amount Field - Always shown */}
                  <Grid item xs={12} md={3}>
                    <TextField
                      label="Amount"
                      type="number"
                      value={transportAmount}
                      onChange={(e) => setTransportAmount(e.target.value)}
                      fullWidth
                    />
                  </Grid>

                  {/* Add Button - Always shown */}
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleAddTransportItem}
                      disabled={
                        !selectedRouteID ||
                        !transportMonth ||
                        !transportAmount ||
                        isNaN(transportAmount)
                      }
                      fullWidth
                      style={{
                        height: '56px',
                        color: "white",
                        backgroundColor: "#ED6C02",
                        width: "100%"
                      }}
                    >
                      +
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Grid>

            {/* Transport Items Table */}
            {selectedTransportItems.length > 0 && (
              <Grid item xs={12}>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Serial No</TableCell>
                        <TableCell>Selected Route</TableCell>
                        <TableCell>Month</TableCell>
                        <TableCell>Amount</TableCell>
                        <TableCell>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedTransportItems.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{item.routeName} ({item.distance} km)</TableCell>
                          <TableCell>
                            {item.month === "All" ? "All months" : item.month}
                          </TableCell>
                          <TableCell>
                            {item.amount}
                            {registrationData.paymentType === "0" && item.month === "All" &&
                              ` (12 × ${item.amount / 12})`}
                          </TableCell>
                          <TableCell>
                            <Button
                              variant="contained"
                              color="error"
                              onClick={() => handleDeleteTransportItem(index)}
                              style={{
                                color: "white",
                                backgroundColor: "#9C27B0"
                              }}
                            >
                              Delete
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}

            {/* Assigned Vehicles Table */}
            {vehicles.length > 0 && (
              <Grid item xs={12}>
                <Typography variant="h6">Assigned Vehicles</Typography>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Vehicle Reg No</TableCell>
                        <TableCell>Fuel Type</TableCell>
                        <TableCell>Capacity</TableCell>
                        <TableCell>Model</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {vehicles.map((vehicle, index) => (
                        <TableRow key={index}>
                          <TableCell>{vehicle.registrationNo}</TableCell>
                          <TableCell>{vehicle.fuelType}</TableCell>
                          <TableCell>{vehicle.seatingCapicity}</TableCell>
                          <TableCell>{vehicle.model}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
          </Grid>

        )} </Paper>
      {/* avail transport ends here */}


      <Typography variant="h6" gutterBottom className="mt-4">
  <b>Avail Hostel</b>
</Typography>

<FormControl component="fieldset">
  <Grid container spacing={2}>
    <Grid item>
      <FormControlLabel
        control={<Radio checked={isHostel === true} onChange={() => { setIsHostel(true); setRegistrationData({ ...registrationData, isHostel: true }); }} name="hostel" color="primary" />}
        label="Yes"
      />
    </Grid>
    <Grid item>
      <FormControlLabel
        control={<Radio checked={isHostel === false} onChange={() => { setIsHostel(false); setRegistrationData({ ...registrationData, isHostel: false }); }} name="hostel" color="primary" />}
        label="No"
      />
    </Grid>
  </Grid>
</FormControl>

{isHostel && (
  <Grid container spacing={2} className="mt-6 items-center mb-6">
    <Grid item xs={12} md={12}>
      <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-md">
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={3}>
            <TextField label="Room No" value={hostelRoomNo} onChange={(e) => setHostelRoomNo(e.target.value)} fullWidth />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl fullWidth>
              <InputLabel id="hostel-month-label">Select Month</InputLabel>
              <Select labelId="hostel-month-label" value={hostelMonth} onChange={(e) => setHostelMonth(e.target.value)} label="Select Month" disabled={registrationData.paymentType === "1"}>
                <MenuItem value="">Select Month</MenuItem>
                <MenuItem value="All">All Months</MenuItem>
                {month.map((item) => (<MenuItem key={item.monthId} value={item.month}>{item.month}</MenuItem>))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField label="Amount" type="number" value={hostelAmount} onChange={(e) => setHostelAmount(e.target.value)} fullWidth />
          </Grid>
          <Grid item xs={12} md={2}>
            <Button variant="contained" onClick={handleAddHostelItem}
              disabled={!hostelMonth || !hostelAmount || isNaN(hostelAmount)}
              fullWidth style={{ height: "56px", color: "white", backgroundColor: "#ED6C02" }}>
              +
            </Button>
          </Grid>
        </Grid>
      </div>
    </Grid>

    {selectedHostelItems.length > 0 && (
      <Grid item xs={12} mt={2}>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Serial No</TableCell>
                <TableCell>Room No</TableCell>
                <TableCell>Month</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedHostelItems.map((item, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{item.roomNo}</TableCell>
                  <TableCell>{item.month === "All" ? "All months" : item.month}</TableCell>
                  <TableCell>
                    {item.amount}
                    {registrationData.paymentType === "0" && item.month === "All" && ` (12 × ${item.amount / 12})`}
                  </TableCell>
                  <TableCell>
                    <Button variant="contained" onClick={() => handleDeleteHostelItem(index)}
                      style={{ color: "white", backgroundColor: "#9C27B0" }}>
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    )}
  </Grid>
)}

      <div>
        <AppBar
          position="static"
          style={{ backgroundColor: "#0B1F3D" }}
          className="mt-4"
        >
          <Toolbar>
            <Typography variant="h5" component="div" style={{ fontWeight: 'bold' }}>
              Parents Details
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
      <Paper elevation={3} style={{ padding: '20px', marginTop: 6 }}>

        <Grid container spacing={3} style={{ marginTop: "1px" }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="fatherName"
              label="Father Name *"
              value={registrationData.fathersNmae || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  fathersNmae: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="motherName"
              label="Mother Name *"
              value={registrationData.mothersName || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  mothersName: e.target.value,
                })
              }
            />
          </Grid>
        </Grid>
        {/* Father's Mobile Number */}
        <Grid container spacing={3} style={{ marginTop: "1px" }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="fathersMobile"
              label="Father's Mobile No. *"
              value={registrationData.fathersMobile || ""}
              onChange={(e) => handleNumericInput(e, "fathersMobile", 10)}
              onBlur={(e) => validateMobile(e.target.value, "Father's Mobile")}
              inputProps={{ maxLength: 10 }}
              type="text"
              error={!!mobileError && registrationData.fathersMobile.length > 0}
              helperText={
                mobileError && registrationData.fathersMobile.length > 0
                  ? mobileError
                  : ""
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="mothersMobile"
              label="Mother's Mobile No."
              value={registrationData.mothersMobile || ""}
              onChange={(e) => handleNumericInput(e, "mothersMobile", 10)}
              onBlur={(e) => validateMobile(e.target.value, "Mother's Mobile")}
              inputProps={{ maxLength: 10 }}
              type="text"
              error={!!mobileError && registrationData.mothersMobile.length > 0}
              helperText={
                mobileError && registrationData.mothersMobile.length > 0
                  ? mobileError
                  : ""
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "1px" }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="fathersEmail"
              label="Father's Email Id"
              value={registrationData.fathersEmail || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  fathersEmail: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="mothersEmail"
              label="Mother's Email Id"
              value={registrationData.mothersEmail || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  mothersEmail: e.target.value,
                })
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "-1px" }}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel htmlFor="fathersOccupationId">
                Father's Profession
              </InputLabel>
              <Select
                fullWidth
                id="fathersOccupationId"
                value={registrationData.fathersOccupationId || ""}
                label="Father's Profession"
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    fathersOccupationId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Occupation</MenuItem>
                {occupation.length > 0 ? (
                  occupation.map((item) => (
                    <MenuItem key={item.occupationID} value={item.occupationID}>
                      {item.occupationName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No occupations available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel htmlFor="mothersOccupationId">
                Mother's Profession
              </InputLabel>
              <Select
                fullWidth
                id="mothersOccupationId"
                label="Mother's Profession"
                value={registrationData.mothersOccupationId || ""}
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    mothersOccupationId: e.target.value,
                  })
                }
              >
                <MenuItem value="">Select Occupation</MenuItem>
                {occupation.length > 0 ? (
                  occupation.map((item) => (
                    <MenuItem key={item.occupationID} value={item.occupationID}>
                      {item.occupationName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No occupations available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "1px" }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="grandFathersName"
              label="Guardian's Name"
              value={registrationData.grandFathersNmae || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  grandFathersNmae: e.target.value,
                })
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "1px" }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="fathersIncome"
              label="Father's Income"
              value={registrationData.fathersIncome || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  fathersIncome: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="mothersIncome"
              label="Mother's Income"
              value={registrationData.mothersIncome || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  mothersIncome: e.target.value,
                })
              }
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "1px" }}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="fathersAdhaar"
              label="Father's Aadhar No."
              value={registrationData.fathersAdhaar || ""}
              onChange={(e) => handleNumericInput(e, "fathersAdhaar", 12)}
              onBlur={(e) => validateAadhaar(e.target.value, "Father's Aadhaar")}
              inputProps={{ maxLength: 12 }}
              type="text"
              error={!!aadhaarError && registrationData.fathersAdhaar.length > 0}
              helperText={
                aadhaarError && registrationData.fathersAdhaar.length > 0
                  ? aadhaarError
                  : ""
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              id="mothersAdhaar"
              label="Mother's Aadhar No."
              value={registrationData.mothersAdhaar || ""}
              onChange={(e) => handleNumericInput(e, "mothersAdhaar", 12)}
              onBlur={(e) => validateAadhaar(e.target.value, "Mother's Aadhaar")}
              inputProps={{ maxLength: 12 }}
              type="text"
              error={!!aadhaarError && registrationData.mothersAdhaar.length > 0}
              helperText={
                aadhaarError && registrationData.mothersAdhaar.length > 0
                  ? aadhaarError
                  : ""
              }
            />
          </Grid>
        </Grid>
        <div style={{ marginTop: "1px" }}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={parentsDobChecked}
                  onChange={() => setParentsDobChecked(!parentsDobChecked)}
                />
              }
              label={<b>Parents DOB</b>}
            />
          </FormGroup>
          {parentsDobChecked && (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  id="fatherDob"
                  label="Father's DOB"
                  type="date"
                  value={formatDateToYYYYMMDD(registrationData.fdob) || ""}
                  onChange={(e) =>
                    setRegistrationData({
                      ...registrationData,
                      fdob: formatDateToDDMMYYYY(e.target.value),
                    })
                  }
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  id="motherDob"
                  label="Mother's DOB"
                  type="date"
                  value={formatDateToYYYYMMDD(registrationData.mdob) || ""}
                  onChange={(e) =>
                    setRegistrationData({
                      ...registrationData,
                      mdob: formatDateToDDMMYYYY(e.target.value),
                    })
                  }
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          )}
        </div>
        <Grid container spacing={3} style={{ marginTop: "1px" }}>
          <Grid item xs={12} sm={6}>
            <TextField
              id="fatherAddress"
              label="Father's Address"
              multiline
              rows={3}
              value={registrationData.fathersAddress || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  fathersAddress: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="motherAddress"
              label="Mother's Address"
              multiline
              rows={3}
              value={registrationData.mothersAddress || ""}
              onChange={(e) =>
                setRegistrationData({
                  ...registrationData,
                  mothersAddress: e.target.value,
                })
              }
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} style={{ marginTop: "1px" }}>
         <Grid item xs={12} md={6}>
  <Typography variant="subtitle1" gutterBottom>
    Father's Profile
  </Typography>
  <Input
    type="file"
    id="fatherprofile"
    onChange={(e) => handleFileChange("fatherprofile", e)}
    fullWidth
  />
  <Typography variant="caption" color="textSecondary">
    Max size: 200KB
  </Typography>
  {registrationData.fathersImagePath && !newFiles.fatherprofile && (
    <Box sx={{ mt: 1 }}>
      <img
        src={`${process.env.REACT_APP_BASE_URL.replace('/api', '')}/${registrationData.fathersImagePath}`}
        alt="Father"
        style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 4 }}
      />
    </Box>
  )}
</Grid>

<Grid item xs={12} md={6}>
  <Typography variant="subtitle1" gutterBottom>
    Mother's Profile
  </Typography>
  <Input
    type="file"
    id="motherprofile"
    onChange={(e) => handleFileChange("motherprofile", e)}
    fullWidth
  />
  <Typography variant="caption" color="textSecondary">
    Max size: 200KB
  </Typography>
  {registrationData.mothersImagePath && !newFiles.motherprofile && (
    <Box sx={{ mt: 1 }}>
      <img
        src={`${process.env.REACT_APP_BASE_URL.replace('/api', '')}/${registrationData.mothersImagePath}`}
        alt="Mother"
        style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 4 }}
      />
    </Box>
  )}
</Grid>
        </Grid>
        <Grid container spacing={3} className="mt-3">
          <Grid item xs={12} md={6}>
            <Typography variant="h5" gutterBottom className="mt-4">
              <b>Choose Stream</b>
            </Typography>
            <FormControl fullWidth style={{ marginBottom: "16px" }}>
              <InputLabel id="stream-label">Stream</InputLabel>
              <Select
                labelId="stream-label"
                id="stream-select"
                value={selectedStream || ""}
                onChange={(e) => setSelectedStream(e.target.value)}
                label="Stream"
              >
                <MenuItem value="">Select Stream</MenuItem>
                {streams.length > 0 ? (
                  streams.map((stream) => (
                    <MenuItem key={stream.streamID} value={stream.streamID}>
                      {stream.streamName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No streams available</MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container spacing={2} className="mt-2">
          <Grid item xs={12} md={6}>
            <Typography variant="h5" gutterBottom className="mt-2">
              <b>Choose Language</b>
            </Typography>
            <FormControl fullWidth>
              <InputLabel id="language-type-label">Language Type</InputLabel>
              <Select
                labelId="language-type-label"
                id="language-type"
                label="Language Type"
                value={selectedLanguageType || ""}
                onChange={(e) => setSelectedLanguageType(e.target.value)}
              >
                <MenuItem value="">Select Language Type</MenuItem>
                <MenuItem value="Hindi">Hindi</MenuItem>
                <MenuItem value="English">English</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Concession Details starts here */}
        <Typography variant="h6" gutterBottom className="mt-4">
          <b>Concession Details</b>
        </Typography>

        <Grid container spacing={2} className="mt-6 items-center mb-6">
          <Grid item xs={12} md={12}>
            <div className="bg-white dark:bg-gray-900 p-6 rounded-lg shadow-md">
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth>
                    <InputLabel id="concession-label">Concession</InputLabel>
                    <Select
                      labelId="concession-label"
                      id="concession"
                      value={selectedConcession}
                      onChange={(e) => setSelectedConcession(e.target.value)}
                      label="Concession"
                    >
                      <MenuItem value="">Select Concession Type</MenuItem>
                      {concessionData.map((item) => (
                        <MenuItem key={item.concessionId} value={item.concessionName}>
                          {item.concessionName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3}>
                  <FormControl fullWidth>
                    <InputLabel id="month-label">Select Month</InputLabel>
                    <Select
                      labelId="month-label"
                      id="month"
                      value={selectedMonth}
                      onChange={(e) => setSelectedMonth(e.target.value)}
                      label="Select Month"
                      disabled={registrationData.paymentType === "1"}
                      fullWidth
                    >
                      <MenuItem value="">Select Month</MenuItem>
                      <MenuItem value="All">All Months</MenuItem>
                      {month.map((item) => (
                        <MenuItem key={item.monthId} value={item.month}>
                          {item.month}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={3}>
                  <TextField
                    label="Amount"
                    type="number"
                    value={selectedAmount}
                    onChange={(e) => setSelectedAmount(e.target.value)}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddItem}
                    disabled={
                      !selectedConcession ||
                      !selectedMonth ||
                      !selectedAmount ||
                      isNaN(selectedAmount)
                    }
                    fullWidth
                    style={{
                      height: '56px',
                      color: "white",
                      backgroundColor: "#ED6C02",
                      width: "100%"
                    }}
                  >
                    +
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Grid>

          {selectedItems.length > 0 && (
            <Grid item xs={12} mt={2}>

              <TableContainer component={Paper}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: 'bold' }}>Serial No</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Concession Type</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Month</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Amount</TableCell>
                      <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedItems.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{item.concession}</TableCell>
                        <TableCell>
                          {registrationData.paymentType === "1" ? "All Months" : item.month}
                        </TableCell>
                        <TableCell>
                          {item.amount}
                          {registrationData.paymentType === "0" && item.month === "All" &&
                            ` (12 × ${item.amount / 12})`}
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => handleDeleteItem(index)}
                            style={{
                              color: "white",
                              backgroundColor: "#9C27B0"
                            }}
                          >
                            Delete
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          )}
        </Grid>

        {/* Concession Details ends here */}

        <Grid container spacing={3} className="mt-3">
          {/* <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox checked={isHostel} onChange={handleHostelChange} />
              }
              label={<b>Is Hostel</b>}
              style={{ marginLeft: "10px" }}
            />
          </Grid> */}
        </Grid>
       <Typography variant="h6" className="mt-3">
  <b>Document</b>
  <Typography variant="caption" color="textSecondary" component="span" sx={{ ml: 1 }}>
    (Max size: 200KB per file)
  </Typography>
</Typography>
        <Grid container spacing={3} className="mt-3">
         <Grid item xs={12} md={6}>
  <Typography variant="subtitle1" gutterBottom>
    Aadhar Card Front
  </Typography>
  <FormControl fullWidth>
    <InputLabel htmlFor="studentAdhaarFrontPath"></InputLabel>
    <Input
      type="file"
      id="studentAdhaarFrontPath"
      onChange={(e) => handleFileChange("studentAdhaarFrontPath", e)}
    />
  </FormControl>
  {registrationData.studentAdhaarFrontPath && !newFiles.studentAdhaarFrontPath && (
    <Box sx={{ mt: 1 }}>
      <img
        src={`${process.env.REACT_APP_BASE_URL.replace('/api', '')}/${registrationData.studentAdhaarFrontPath}`}
        alt="Aadhar Front"
        style={{ width: 120, height: 80, objectFit: "cover", borderRadius: 4 }}
      />
    </Box>
  )}
</Grid>
         <Grid item xs={12} md={6}>
  <Typography variant="subtitle1" gutterBottom>
    Aadhar Card Back
  </Typography>
  <FormControl fullWidth>
    <InputLabel htmlFor="studentAdhaarBackPath"></InputLabel>
    <Input
      type="file"
      id="studentAdhaarBackPath"
      onChange={(e) => handleFileChange("studentAdhaarBackPath", e)}
    />
  </FormControl>
  {registrationData.studentAdhaarBackPath && !newFiles.studentAdhaarBackPath && (
    <Box sx={{ mt: 1 }}>
      <img
        src={`${process.env.REACT_APP_BASE_URL.replace('/api', '')}/${registrationData.studentAdhaarBackPath}`}
        alt="Aadhar Back"
        style={{ width: 120, height: 80, objectFit: "cover", borderRadius: 4 }}
      />
    </Box>
  )}
</Grid>
         <Grid item xs={12} md={6}>
  <Typography variant="subtitle1" gutterBottom>
    Birth Certificate
  </Typography>
  <FormControl fullWidth>
    <InputLabel htmlFor="birtcertificatePath"></InputLabel>
    <Input
      type="file"
      id="birtcertificatePath"
      onChange={(e) => handleFileChange("birtcertificatePath", e)}
    />
  </FormControl>
  {registrationData.birtcertificatePath && !newFiles.birtcertificatePath && (
    <Typography variant="caption" display="block" sx={{ mt: 1 }}>
      
        <a href={`${process.env.REACT_APP_BASE_URL.replace('/api', '')}/${registrationData.birtcertificatePath}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        View existing file
      </a>
    </Typography>
  )}
</Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" gutterBottom>
              Transfer Certificate
            </Typography>
            <FormControl fullWidth>
              <InputLabel htmlFor="trfCertificatePath"></InputLabel>
              <Input
                type="file"
                id="trfCertificatePath"
                onChange={(e) => handleFileChange("trfCertificatePath", e)}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" gutterBottom>
              Others
            </Typography>
            <FormControl fullWidth>
              <InputLabel htmlFor="othetFilePath"></InputLabel>
              <Input
                type="file"
                id="othetFilePath"
                onChange={(e) => handleFileChange("othetFilePath", e)}
              />
            </FormControl>
          </Grid>
        </Grid>
      </Paper>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
        }}
      >
        <Grid item xs={12} md={6}>
          <Tooltip
            title={seatExceeded ? "Cannot update: Seats exceeded for this class/section" : ""}
            arrow>
            <button
              type="button"
              className="mt-2 mx-2 btn btn-primary"
              style={{
                width: "100px",
                height: "50px",
                padding: "10px 0",
                fontWeight: 'bold'
              }}
              onClick={handleSave}
              disabled={seatExceeded}
            >
              UPDATE
            </button> </Tooltip>
        </Grid>
        <Grid item xs={12} md={6}>
          <button type="button" className="mt-2 mx-2 btn btn-danger"
            style={{
              width: "100px",
              height: "50px",
              padding: "10px 0",
              fontWeight: 'bold'
            }}

            onClick={() => { navigate(-1) }}>
            CANCEL
          </button>
        </Grid>
      </div>
      {/* Registration Details Modal */}
      <Modal
        open={showModal}
        onClose={handleClose}
        aria-labelledby="registration-modal-title"
        aria-describedby="registration-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Box sx={{ backgroundColor: "#3498db", color: "#fff", p: 2, borderRadius: "4px 4px 0 0" }}>
            <Typography id="registration-modal-title" variant="h6">
              Registration Details
            </Typography>
          </Box>
          <Box sx={{ p: 2 }}>
            <div className="table-responsive">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Registration No</TableCell>
                    <TableCell>Student Name</TableCell>
                    <TableCell>Registration Date</TableCell>
                    <TableCell>Mobile No</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {regisData.length > 0 ? (
                    regisData.map((registration) => (
                      <TableRow key={registration.registrationId}>
                        <TableCell>{registration.registrationNo}</TableCell>
                        <TableCell>{registration.name}</TableCell>
                        <TableCell>{registration.dated}</TableCell>
                        <TableCell>{registration.mobileNo}</TableCell>
                        <TableCell></TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5}>No registration data available</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
            <Button variant="contained" onClick={handleClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Validation Modal */}
      <Modal
        open={showValidationModal}
        onClose={handleCloseValidationModal}
        aria-labelledby="validation-modal-title"
        aria-describedby="validation-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Custom Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography variant="h6" sx={{ color: '#fff' }}>
              Required Fields Missing
            </Typography>
          </Box>

          {/* Content Area */}
          <Box sx={{ padding: '20px' }}>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Please fill in the following required fields:
            </Typography>
            <ul style={{ paddingLeft: '1.2rem', margin: 0 }}>
              {missingFields.map((field, index) => (
                <li key={index}>
                  <Typography variant="body2">- {field}</Typography>
                </li>
              ))}
            </ul>
          </Box>

          {/* Action Button */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: '0 20px 20px' }}>
            <Button
              onClick={handleCloseValidationModal}
              variant="contained"
              color="primary"
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>


      {/* Success Modal */}
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            overflow: "hidden",
          }}
        >
          <Box sx={{ backgroundColor: "#0B1F3D", padding: "12px 16px" }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: "#fff" }}>
              Admission Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: "20px" }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Admission data is successfully updated for this student.
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>   
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>

 </Container>
  );
};

export default UpdateAdmission;